export default {"src":"/_next/static/media/reusable.d03a9f35.svg","height":16,"width":16};